import { getToken } from "../../../services/authService";

const API = process.env.REACT_APP_API_URL;

const authJsonHeaders = () => {
    const t = getToken();
    return {
        Authorization: `Bearer ${t}`,
        "Content-Type": "application/json",
    };
};

const authHeaders = () => {
    const t = getToken();
    return { Authorization: `Bearer ${t}` };
};

export async function fetchPersonaById(personaId) {
    const res = await fetch(`${API}/api/personas/${personaId}`, { headers: authJsonHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function savePersona({ personaId, payload }) {
    const url = personaId ? `${API}/api/personas/${personaId}` : `${API}/api/personas`;
    const method = personaId ? "PUT" : "POST";

    const res = await fetch(url, {
        method,
        headers: authJsonHeaders(),
        body: JSON.stringify(payload),
    });

    if (!res.ok) {
        const txt = await res.text().catch(() => "");
        throw new Error(txt || `HTTP ${res.status}`);
    }

    return res.json();
}

export async function deleteArmaById(armaId) {
    const res = await fetch(`${API}/api/armas/delete/${armaId}`, {
        method: "DELETE",
        headers: authHeaders(),
    });
    if (!res.ok) {
        const txt = await res.text().catch(() => "");
        throw new Error(txt || `HTTP ${res.status}`);
    }
    return true;
}

export async function fetchPersonasAll() {
    const res = await fetch(`${API}/api/personas/all`, { headers: authHeaders() });
    if (!res.ok) throw new Error(`Error ${res.status}: ${res.statusText}`);
    return res.json();
}

export async function deletePersona(personaId) {
    const res = await fetch(`${API}/api/personas/${personaId}`, {
        method: "DELETE",
        headers: authJsonHeaders(),
    });

    // Aquí NO lanzamos directamente, porque el backend devuelve JSON con {codigo, mensaje, detalles}
    // y la UI lo usa para InfoModal.
    return res;
}

export async function setBaja(personaId) {
    const res = await fetch(`${API}/api/personas/${personaId}/baja`, {
        method: "PATCH",
        headers: authHeaders(),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function setActiva(personaId) {
    const res = await fetch(`${API}/api/personas/${personaId}/reactivar`, {
        method: "PATCH",
        headers: authHeaders(),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}
